import routes from '@modules/player/player-routes';
import store from '@modules/player/player-store';

export default {
  routes,
  store,
};
